const dataSource = {
  firestore: 'firestore',
  cloudStorage: 'cloudStorage'
};

export default dataSource;

